import { config } from "@fullcalendar/core/internal";
import axios from "axios";
import React, { createContext, useState } from "react";
import { toast } from "sonner";
export const StoreContext = createContext();

const Store = ({ children }) => {
  // const baseURL = "http://192.168.0.98:5000";
  const baseURL = process.env.REACT_APP_BASE_URL;

  const [user, setUser] = useState(null);
  const [userid, setUserid] = useState(null)
  const [database, setDatabase] = useState(null);
  const [loading, setLoading] = useState(false);
  const [level0Metrics, setLevel0Metrics] = useState([]);
  const [childMetrics, setChildMetrics] = useState([]);
  const [masterTables, setMasterTables] = useState([]);
  const [masterTableColumns, setMasterTableColumns] = useState([]);
  const [searchResult, setSearchResult] = useState([]);
  const [searchResultLoader, setSearchResultLoader] = useState(false);
  const [chatData, setChatData] = useState([]);
  const [chatResponseLoader, setChatResponseLoader] = useState(false);
  const [overAllKPI, setOverAllKPI] = useState([]);
  const [metricKPI, setMetricKPI] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [parentMetrics, setParentMetrics] = useState([]);
  const [activeNavbar, setActiveNavbar] = useState(null);
  const [customMetric, setCustomMetric] = useState([]);
  const [databaseConfigs, setDatabaseConfigs] = useState([]);
  const [comparisonMetrics, setComparisonMetrics] = useState([]);
  const [childComparisonMetrics, setChildComparisonMetrics] = useState([]);

  async function fetchUserData() {
    setLoading(true);
    try {
      const response = await axios.post(
        `${baseURL}/api/auth/user/protected`,
        {},
        {
          withCredentials: true,
        }
      );
      if (response.status === 200) {
        if (response.data.user.role == 1) {
          console.log(response.data.active);
          if (!response.data.active) {
            localStorage.clear();
            try {
              await axios.post(
                `${baseURL}/api/auth/cleartoken`,
                {},
                { withCredentials: true }
              );
            } catch (err) {
              console.error("Failed to clear token:", err);
            }

            setUser(null);
            toast.warning(response.data.message);
            return null;
          }
          console.log("response.data.user", response.data.user);
          if (!response.data.user.config_id) {
            localStorage.setItem("userid", response.data.user.user_id);
            localStorage.setItem("role", response.data.user.role);
            setUser(response.data.user.user_id);
          } else {
            localStorage.setItem("userid", response.data.user.user_id);
            localStorage.setItem("role", response.data.user.role);
            localStorage.setItem("configid", response.data.user.config_id);
            setUser(response.data.user.user_id);
            setUserid(response.data.user.user_id);
            setDatabase(response.data.user.config_id);
          }
          return response.data.user;
        } else {
          localStorage.clear();
          toast.warning("You are not authenticated");
        }
      } else {
        toast.error("User not found!");
        setUser(null);
      }
    } catch (error) {
      if (
        !error.response ||
        error.response.status === 401 ||
        error.response.status === 403 ||
        error.response.status === 404
      ) {
        localStorage.clear();
        setUser(null);
        console.error(error);
        toast.error(
          error.response?.data?.message || "Network error. Please try again."
        );
      } else {
      }

      setUser(null);
    } finally {
      setLoading(false);
    }
  }

  // async function fetchDatabasedata(configdbid) {
  //   setLoading(true);
  //   try {
  //     const response = await axios.post(
  //       `${baseURL}/api/auth/database/protected`,
  //       {
  //         config_id: configdbid,
  //       }
  //     );

  //     if (response.data.database) {
  //       setDatabase(response.data.database.config_id);
  //       localStorage.setItem("configid", response.data.database.config_id);
  //       return response.data.database;
  //     } else {
  //       toast.error("Database not found!");
  //       setDatabase(null);
  //       return null;
  //     }
  //   } catch (error) {
  //     console.error(error);
  //     toast.error(
  //       error.response?.data?.message || "Network error. Please try again."
  //     );
  //     return null;
  //   } finally {
  //     setLoading(false);
  //   }
  // }

  async function login(userData, navigate) {
    setLoading(true);
    try {
      const response = await axios.post(
        `${baseURL}/api/auth/adminlogin`,
        userData,
        {
          withCredentials: true,
        }
      );

      const data = response.data;

      if (response.status === 200) {
        const user = await fetchUserData();

        console.log("usersds", user);

        if (!user || typeof user !== "object") {
          toast.error("Invalid user data received");
          return;
        }

        const { role, config_id } = user;

        if (role !== 1) {
          toast.warning("You are not authorized to access this area.");
          return;
        }

        // if (!config_id) {
        //   toast.warning(
        //     "No configuration found for this user. Please contact the administrator."
        //   );
        //   return;
        // }

        toast.success(data.message);
        console.log(user);
        navigate("/database-configurations");
        console.log(localStorage.getItem("configid"));
        // const configArray = localStorage
        //   .getItem("configid")
        //   .split(",")
        //   .map(Number);

        // console.log(configArray);
      } else {
        toast.error("Something went wrong during login!");
      }
    } catch (error) {
      toast.error(
        error.response?.data?.message || "An error occurred during login"
      );
    } finally {
      setLoading(false);
    }
  }

  async function logout() {
    setLoading(true);
    try {
      localStorage.clear();
      await axios.post(
        `${baseURL}/api/auth/cleartoken`,
        {},
        { withCredentials: true }
      );

      setUser(null);
      setUserid(null);
      toast.success("Logged out successfully");
    } catch (error) {
      console.error("Logout error:", error);
      toast.error("Logout failed");
    } finally {
      setLoading(false);
    }
  }

  async function getDatabaseConfigs(userid) {
    setLoading(true);
    try {
      const response = await axios.post(`${baseURL}/api/auth/adminconfigs`, {
        userid,
      });
      const data = response.data;

      if (data) {
        setDatabaseConfigs(data.data);
      } else {
        toast.error("Something went wrong!");
      }
    } catch (error) {
      console.error(error);
      toast.error(error.response?.data?.message || "An error occurred");
    } finally {
      setLoading(false);
    }
  }

  async function selectSpecificDatabase(config_id, navigate) {
    setLoading(true);
    localStorage.setItem("configid", config_id);
    try {
      const response = await axios.post(
        `${baseURL}/api/auth/selectedconfig`,
        {
          config_id,
        },
        {
          withCredentials: true,
        }
      );
      const data = response.data;

      if (data) {
        const user = await fetchUserData();
        console.log(user);
        setDatabaseConfigs(data.message);
        setLevel0Metrics([]);
        setTableData([]);
        setOverAllKPI([]);
        setComparisonMetrics([]);
        setTimeout(() => {
          navigate("/");
        }, 100);
      } else {
        toast.error("Something went wrong!");
      }
    } catch (error) {
      console.error(error);
      toast.error(error.response?.data?.message || "An error occurred");
    } finally {
      setLoading(false);
    }
  }

  async function getLevel0Metrics(configdbid) {
    setLoading(true);
    try {
      const response = await axios.post(`${baseURL}/api/getlevelzerometrics`, {
        config_id: configdbid,
      });
      const data = response.data;

      if (data) {
        setLevel0Metrics(data.data);
      } else {
        toast.error("Something went wrong!");
      }
    } catch (error) {
      console.error(error);
      toast.error(error.configResponse?.data?.message || "An error occurred");
    } finally {
      setLoading(false);
    }
  }

  async function getChildMetrics(configdbid, metricid) {
    setLoading(true);
    try {
      const response = await axios.post(`${baseURL}/api/getchildmetrics`, {
        config_id: configdbid,
        metric_id: metricid,
      });

      const data = response.data;

      if (data) {
        setChildMetrics(data.data);
      } else {
        toast.error("Something went wrong!");
      }
    } catch (error) {
      console.error(error);
      toast.error(error.response?.data?.message || "An error occurred");
    } finally {
      setLoading(false);
    }
  }

  async function getParentComparison(configdbid) {
    setLoading(true);
    console.log("compare out");
    try {
      const response = await axios.post(
        `${baseURL}/api/getlevelzerocomparecharts`,
        {
          config_id: configdbid,
        }
      );
      console.log("compare");
      const data = response.data;

      if (data) {
        setComparisonMetrics(data.data);
      } else {
        toast.error("Something went wrong!");
      }
    } catch (error) {
      console.error(error);
      toast.error(error.data?.message || "An error occurred");
    } finally {
      setLoading(false);
    }
  }

  async function getChildComparison(configdbid, metric_id) {
    setLoading(true);
    try {
      const response = await axios.post(
        `${baseURL}/api/getchildcomparecharts`,
        {
          config_id: configdbid,
          metric_id: metric_id,
        }
      );
      const data = response.data;

      if (data) {
        setChildComparisonMetrics(data.data);
      } else {
        toast.error("Something went wrong!");
      }
    } catch (error) {
      console.error(error);
      toast.error(error.data?.message || "An error occurred");
    } finally {
      setLoading(false);
    }
  }

  async function getMasterTables(configdbid) {
    setLoading(true);
    try {
      const response = await axios.post(
        `${baseURL}/api/search/getmastertablesforsearch`,
        {
          config_id: configdbid,
        }
      );

      const data = response.data;

      if (data) {
        setMasterTables(data.data);
      } else {
        toast.error("Something went wrong!");
      }
    } catch (error) {
      console.error(error);
      toast.error(error.response?.data?.message || "An error occurred");
    } finally {
      setLoading(false);
    }
  }

  async function getColumnForMasterTable(configdbid, tablename) {
    setLoading(true);
    try {
      const response = await axios.post(
        `${baseURL}/api/search/getcolumnsfortablessearch`,
        {
          config_id: configdbid,
          table_name: tablename,
        }
      );

      const data = response.data;

      if (data) {
        setMasterTableColumns(data.data);
      } else {
        toast.error("Something went wrong!");
      }
    } catch (error) {
      console.error(error);
      toast.error(error.response?.data?.message || "An error occurred");
    } finally {
      setLoading(false);
    }
  }

  async function aiSearchResult(input) {
    setLoading(true);
    setSearchResultLoader(true);
    try {
      const response = await axios.post(
        `${baseURL}/api/search/aisearchbyentity`,
        {
          config_id: input.configid,
          table_name: input.table_name,
          column_name: input.column_name,
          input: input.input,
        }
      );

      const data = response.data;

      if (data) {
        setSearchResult(data.data);
      } else {
        toast.error("Something went wrong!");
      }
    } catch (error) {
      console.error(error);
      toast.error(error.response?.data?.message || "An error occurred");
    } finally {
      setLoading(false);
      setSearchResultLoader(false);
    }
  }

  async function aiChatBot(input) {
    setLoading(true);
    setChatResponseLoader(true);
    try {
      const response = await axios.post(`${baseURL}/api/chat/aichatbot`, {
        config_id: input.configid,
        conversation_history: input.conversation_history || [],
      });
      const data = response.data;
      if (data && data.data) {
        return data.data;
      } else {
        toast.error("Something went wrong!");
        return null;
      }
    } catch (error) {
      console.error(error);
      toast.error(error.response?.data?.message || "An error occurred");
      return null;
    } finally {
      setLoading(false);
      setChatResponseLoader(false);
    }
  }

  async function getOverAllKPI(config_id) {
    setLoading(true);
    try {
      const response = await axios.post(`${baseURL}/api/overallkpi`, {
        config_id,
      });

      const data = response.data;

      if (data) {
        setOverAllKPI(data.data);
      } else {
        toast.error("Something went wrong!");
      }
    } catch (error) {
      console.error(error);
      toast.error(error.response?.data?.message || "An error occurred");
    } finally {
      setLoading(false);
    }
  }

  async function getMetricKPI(config_id, metric_id) {
    setLoading(true);
    try {
      const response = await axios.post(`${baseURL}/api/metrickpi`, {
        config_id,
        metric_id,
      });

      const data = response.data;

      if (data) {
        setMetricKPI(data.data);
      } else {
        toast.error("Something went wrong!");
      }
    } catch (error) {
      console.error(error);
      toast.error(error.response?.data?.message || "An error occurred");
    } finally {
      setLoading(false);
    }
  }

  async function getTableData(config_id) {
    setLoading(true);
    try {
      const response = await axios.post(`${baseURL}/api/gettabledata`, {
        config_id,
      });

      const data = response.data;

      if (data) {
        setTableData(data.data);
      } else {
        toast.error("Something went wrong!");
      }
    } catch (error) {
      console.error(error);
      toast.error(error.response?.data?.message || "An error occurred");
    } finally {
      setLoading(false);
    }
  }

  async function getParentMetrics(config_id) {
    setLoading(true);
    try {
      const response = await axios.post(`${baseURL}/api/getdrillmetric`, {
        config_id,
      });

      const data = response.data;

      if (data) {
        setParentMetrics(data.data);
      } else {
        toast.error("Something went wrong!");
      }
    } catch (error) {
      console.error(error);
      toast.error(error.response?.data?.message || "An error occurred");
    } finally {
      setLoading(false);
    }
  }

  async function getCustomMetric(config_id) {
    setLoading(true);
    try {
      const response = await axios.post(`${baseURL}/api/getcustommetric`, {
        config_id,
      });

      const data = response.data;

      if (data) {
        setCustomMetric(data.data);
      } else {
        toast.error("Something went wrong!");
      }
    } catch (error) {
      console.error(error);
      toast.error(error.response?.data?.message || "An error occurred");
    } finally {
      setLoading(false);
    }
  }

  const value = {
    fetchUserData,
    // fetchDatabasedata,
    login,
    logout,
    getLevel0Metrics,
    getChildMetrics,
    getMasterTables,
    getColumnForMasterTable,
    aiSearchResult,
    aiChatBot,
    getOverAllKPI,
    getMetricKPI,
    getTableData,
    getParentMetrics,
    getCustomMetric,
    getDatabaseConfigs,
    selectSpecificDatabase,
    getParentComparison,
    getChildComparison,

    setSearchResultLoader,
    setChatData,
    setChatResponseLoader,
    setActiveNavbar,
    setUserid,

    user,
    userid,
    database,
    loading,
    level0Metrics,
    childMetrics,
    masterTables,
    masterTableColumns,
    searchResult,
    searchResultLoader,
    chatData,
    chatResponseLoader,
    overAllKPI,
    metricKPI,
    tableData,
    parentMetrics,
    activeNavbar,
    customMetric,
    databaseConfigs,
    comparisonMetrics,
    childComparisonMetrics,
  };

  return (
    <StoreContext.Provider value={value}>{children}</StoreContext.Provider>
  );
};

export default Store;
